import React, { FormEvent, useCallback } from 'react';

import PropertySearchForm from '~/components/Common/Forms/PropertySearchForm';

export default function PropertiesSearchContainer() {
  const handleSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  }, []);

  return <PropertySearchForm handleSubmit={handleSubmit} showTable={'property'} searchType={'property'} />;
}
